import { render } from "./SortCaret.vue?vue&type=template&id=50b4c712"
import script from "./SortCaret.vue?vue&type=script&lang=js"
export * from "./SortCaret.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/citizenm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__